import React, { lazy } from 'react';
import { CreateRoot } from '../../assets/js/react';
const QuotationPage = lazy(() => import("../../assets/js/react/components/quotation"));
const element = document.getElementById('quotation-page');
const vaccineDescriptionElement = document?.getElementById('quotation-description-vaccine');
const vouchersDescriptionElement = document?.getElementById('quotation-description-vouchers');
const vaccineDescription = vaccineDescriptionElement?.innerHTML || '';
const fluVouchersDescription = vouchersDescriptionElement?.innerHTML || '';

CreateRoot(
  'quotation-page',
  <QuotationPage vaccineDescription={vaccineDescription} fluVoucherDescription={fluVouchersDescription} />,
);
